
import Vue, { PropType } from 'vue';
import Icon, { Icon as IconName } from '@/common/icon/Icon.vue';
import { Theme } from '@/side-bar/side-bar-config.interface';

export default Vue.extend({
    components: {
        Icon
    },

    props: {
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        theme: {
            type: Object as PropType<Theme>,
            default: () => ({})
        },
        isPrivateQna: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            icon: IconName.question
        };
    }
});
